"use client";

import Image from "@/components/Image";
import { useState, useRef, useEffect } from "react";
// import { DeviceType, getDeviceTypeByUA } from "@/app/utils";
const Home = () => {
  const [showPreview, setShowPreview] = useState(false);
  const buttonRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [deviceType, setDeviceType] = useState<string>("other");

  // 在组件挂载时获取设备类型
  useEffect(() => {
    import("current-device").then((module) => {
      const deviceType = module.default.type;
      setDeviceType(deviceType);
      if (deviceType === "desktop") {
        setDeviceType("pc");
      }
      if (deviceType === "unknown") {
        setDeviceType("other");
      }
    });
  }, []);
  // 检测屏幕宽度变化
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(document.documentElement.clientWidth <= 768);
    };

    // 初始检查
    checkIfMobile();

    // 监听窗口大小变化
    window.addEventListener("resize", checkIfMobile);

    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);

  return (
    <section
      id="home-section"
      className="flex flex-row justify-center items-center w-full bg-[#212121] px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px] gap-[10px] mx-auto overflow-hidden relative"
    >
      {/* 背景部分 */}
      <div className="absolute inset-0 max-w-[1920px] h-[510px] bg-[#212121] mx-auto flex justify-between">
        <Image
          src={isMobile ? "/bg_banner.png" : "/banner_02.jpg"}
          alt="Banner Background"
          width={1920}
          height={510}
          className="object-cover w-[1920px] h-[510px]"
          style={{ objectPosition: "center" }}
        />
      </div>

      {/* 内容部分 */}
      <div className="relative w-full max-w-[1360px] min-h-[510px] mx-auto flex flex-row justify-between py-6 md:py-0">
        {/* 左边内容区域 */}
        <div className="flex flex-col w-full min-h-[248px] gap-[60px] justify-center [@media(max-width:660px)]:pb-[50px]">
          {/* 上面部分 - 图片和文字 */}
          <div className="flex flex-col w-full max-w-[568px] gap-[30px]">
            {/* Logo图片 */}
            <div
              className={`${isMobile ? "h-auto w-full" : "h-[74px] w-[568px]"} `}
            >
              <Image
                src="/tittle_02.png"
                alt="赋能与教学Logo"
                width={568}
                height={74}
                className={`${isMobile ? "h-auto w-full" : "h-[74px] w-[568px]"} mx-0`}
              />
            </div>

            {/* 文字内容 */}
            <p className="w-full  font-light text-[24px]  [@media(max-width:414px)]:text-[18px] leading-tight md:leading-[28px] tracking-[0.5px] md:tracking-[1px] lg:tracking-[2px] text-white text-left">
              关注学生的成长发展 助力教学的提质增效
            </p>
          </div>

          {/* 下面部分 - 两个按钮 */}
          <div className="flex flex-row [@media(max-width:660px)]:flex-col w-[410px] h-[56px] gap-[24px]  mx-0">
            {/* 第一个按钮 - 绿色 */}
            <div className="relative w-[193px]">
              <button
                ref={buttonRef}
                className="flex items-center justify-center w-[193px] h-[56px] rounded-[30px] py-[14px] px-[30px] bg-[#1DBA55] text-white text-[18px] font-medium hover:bg-opacity-90 transition-all"
                onMouseEnter={() => setShowPreview(true)}
                onMouseLeave={() => setShowPreview(false)}
                onClick={() => {
                  window.Log.action(
                    "banner_button_click",
                    {
                      button: "免费个人版使用",
                      user_access_port: deviceType,
                    },
                    "HWOfficialMainPage",
                  );
                }}
              >
                免费个人版使用
              </button>

              {/* 悬停时显示的预览图 */}
              {showPreview && (
                <div className="absolute w-full top-[-260px] max-w-[238px] h-[235px] p-[30px_24px] rounded-[12px] bg-white shadow-[2px_4px_30px_rgba(45,47,49,0.16)] flex flex-col gap-[30px] z-10">
                  {/* <!-- 内部div --> */}
                  <div className="w-[190px] h-[175px] flex flex-col gap-[15px] mx-auto">
                    {/* <!-- 图片区域 --> */}
                    <Image
                      src="/mini_program_left_09.png"
                      alt="免费个人版预览"
                      height={140}
                      width={146.36}
                      className="w-[146.36px] h-[140px] object-contain"
                    />

                    {/* <!-- 空内容区域 --> */}
                    <div className="w-[101px] h-[20px] flex gap-[2px] rounded-full px-4">
                      {/* <!-- 微信图标 --> */}
                      <Image
                        src="/weixin 3.png"
                        alt="微信扫码"
                        width={22}
                        height={20}
                        className="w-[22px] h-[20px] object-contain"
                      />

                      {/* <!-- 文本 --> */}
                      <span className="text-black font-[PingFang_SC] font-normal text-[12px] leading-[20px] tracking-[1px] whitespace-nowrap">
                        微信扫码体验
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* 第二个按钮 - 透明带边框 */}
            <a
              href="https://mifengjiaoyu.feishu.cn/share/base/form/shrcnPtXd6gal9wBuRiBUpjLrKb?prefill_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=%E5%AE%98%E7%BD%91&hide_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=1"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-[193px] h-[56px] rounded-[30px] py-[14px] px-[30px] bg-white/30 text-white text-[18px] font-medium transition-all backdrop-blur-sm border border-white/20"
              onClick={() => {
                window.Log.action(
                  "banner_button_click",
                  {
                    button: "付费校园版咨询",
                    user_access_port: deviceType,
                  },
                  "HWOfficialMainPage",
                );
              }}
            >
              付费校园版咨询
            </a>
          </div>
        </div>

        {/* 右边内容区域 - 在小屏幕上隐藏 */}
        <div
          className={`${isMobile ? "hidden" : "flex"} w-full right-0 max-w-[633px] h-atuo justify-center self-end`}
          // 添加 h-full 和 self-end
        >
          <Image
            src="/pic_02.png"
            alt="Product Showcase"
            width={600}
            height={450}
            className="object-contain w-full h-auto max-w-[90%] md:max-w-full"
          />
        </div>
      </div>
    </section>
  );
};

export default Home;
